import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const AdvancedGeneratorIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_1490_32581)">
        <path
          d="M10.5655 5.67076C10.8252 5.93046 11.2463 5.93046 11.506 5.67076C11.7657 5.41106 11.7657 4.99001 11.506 4.73031L7.97044 1.19477C7.71074 0.935075 7.28969 0.935075 7.02999 1.19477L3.49446 4.73031C3.23476 4.99001 3.23476 5.41106 3.49446 5.67076C3.75416 5.93046 4.17521 5.93046 4.43491 5.67076L6.80237 3.30329L6.80237 10.0355C6.80237 10.4028 7.10011 10.7005 7.46737 10.7005C7.83464 10.7005 8.13237 10.4028 8.13237 10.0355L8.13237 3.23761L10.5655 5.67076Z"
          fill={fillColor || '#9D9DA6'}
        />
        <path
          d="M3.5 7.59644C1.567 7.59644 0 9.16344 0 11.0964C0 13.0294 1.567 14.5964 3.5 14.5964H11.5C13.433 14.5964 15 13.0294 15 11.0964C15 9.16344 13.433 7.59644 11.5 7.59644C10.7155 7.59644 10.6632 8.92644 11.5 8.92644C12.6985 8.92644 13.67 9.89798 13.67 11.0964C13.67 12.2949 12.6985 13.2664 11.5 13.2664H3.5C2.30154 13.2664 1.33 12.2949 1.33 11.0964C1.33 9.89798 2.30154 8.92644 3.5 8.92644C4.33681 8.92644 4.2845 7.59644 3.5 7.59644Z"
          fill={fillColor || '#9D9DA6'}
        />
        <path
          d="M7.05237 3.30329V2.69974L6.6256 3.12652L4.25813 5.49398C4.09606 5.65605 3.8333 5.65605 3.67123 5.49398C3.50917 5.33192 3.50917 5.06915 3.67123 4.90708L7.20677 1.37155C7.36883 1.20948 7.6316 1.20948 7.79367 1.37155L11.3292 4.90708C11.4913 5.06915 11.4913 5.33192 11.3292 5.49398C11.1671 5.65605 10.9044 5.65605 10.7423 5.49398L8.30915 3.06083L7.88237 2.63406V3.23761L7.88237 10.0355C7.88237 10.2647 7.69657 10.4505 7.46737 10.4505C7.23818 10.4505 7.05237 10.2647 7.05237 10.0355L7.05237 3.30329ZM0.25 11.0964C0.25 9.30151 1.70507 7.84644 3.5 7.84644C3.61757 7.84644 3.69824 7.89309 3.75525 7.96268C3.81681 8.03783 3.85571 8.14765 3.85804 8.26635C3.86038 8.38514 3.82582 8.49089 3.76872 8.56172C3.71694 8.62595 3.63564 8.67644 3.5 8.67644C2.16347 8.67644 1.08 9.75991 1.08 11.0964C1.08 12.433 2.16347 13.5164 3.5 13.5164H11.5C12.8365 13.5164 13.92 12.433 13.92 11.0964C13.92 9.75991 12.8365 8.67644 11.5 8.67644C11.3644 8.67644 11.2831 8.62595 11.2313 8.56172C11.1742 8.49089 11.1396 8.38514 11.142 8.26635C11.1443 8.14765 11.1832 8.03783 11.2448 7.96268C11.3018 7.89309 11.3824 7.84644 11.5 7.84644C13.2949 7.84644 14.75 9.30151 14.75 11.0964C14.75 12.8914 13.2949 14.3464 11.5 14.3464H3.5C1.70507 14.3464 0.25 12.8914 0.25 11.0964Z"
          stroke={fillColor || 'url(#paint0_linear_1490_32581)'}
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1490_32581"
          x="0"
          y="0"
          width="15"
          height="14.5957"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1490_32581" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1490_32581" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1490_32581" x1="7.5" y1="1" x2="7.5" y2="14.5964" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { AdvancedGeneratorIcon };
